import { HandledError } from '~/types/handled-error';
import {
  FindMedicalInstitutionWithReservationPreferenceByIdQuery,
  MedicalInstitutionForAppointmentFragmentDoc,
} from '../../gen/medinavi-backend-consumer-graphql/graphql';
import { useFragment as getFragmentData } from '../../gen/medinavi-backend-consumer-graphql/fragment-masking';

export function getValidAppointmentMedicalInstitution(
  medicalInstitutionId: string,
  data: FindMedicalInstitutionWithReservationPreferenceByIdQuery | undefined,
) {
  const medicalInstitutionFragmentRef = data?.medicalInstitution;
  if (medicalInstitutionFragmentRef == null) {
    throw new HandledError(
      new Error(`medicalInstitution must be non-null. medicalInstitutionId = ${medicalInstitutionId}`),
      {
        shouldSendToSentry: true,
        requireReStart: false,
      },
    );
  }

  const medicalInstitution = getFragmentData(
    MedicalInstitutionForAppointmentFragmentDoc,
    medicalInstitutionFragmentRef,
  );

  const medicoHospital = medicalInstitution.medicoHospital;
  if (medicoHospital == null) {
    throw new HandledError(
      new Error(`medicoHospital must be non-null. medicalInstitutionId = ${medicalInstitutionId}`),
      {
        shouldSendToSentry: true,
        requireReStart: false,
      },
    );
  }

  return { medicalInstitution, medicoHospital };
}
